var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resetCode)?_c('div',{staticClass:"reset-password"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.step == 1)?_c('verify-step',{key:_vm.step,attrs:{"emailObj":_vm.obj},on:{"next":_vm.handleStepVerify}}):_vm._e(),(_vm.step == 2)?_c('password-step',{key:_vm.step,attrs:{"emailObj":_vm.obj}}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }